import * as React from 'react';
import { PanelRow, PanelCell, Grid, Cell, Button } from '@teamsnap/teamsnap-ui';
import UUIDSearchForm from './uuid-search-form';
import './org-edit-additional-legacy-section.scss';

export interface Props {
  additionalLegacyOrgs: [any];
  setAdditionalLegacyOrgUuids: Function;
  mainLegacyUuid: number;
}

const OrgEditAdditionalLegacyOrgsSection: React.FunctionComponent<Props> = ({
  additionalLegacyOrgs,
  setAdditionalLegacyOrgUuids,
  mainLegacyUuid,
}) => {
  const [newLegacyOrgs, setNewLegacyOrgs] = React.useState([]);

  const setStubOrgData = (orgStub) => {
    // Using != on purpose to handle string or number format
    if (orgStub.id != mainLegacyUuid) {
      const newOrgStubs = newLegacyOrgs.find((uuid) => uuid === orgStub.id)
        ? newLegacyOrgs
        : newLegacyOrgs.concat(orgStub);
      const orgUuids = (additionalLegacyOrgs || [])
        .map((stub) => stub.id)
        .concat(newOrgStubs.map((stub) => stub.id));

      setNewLegacyOrgs(newOrgStubs);
      setAdditionalLegacyOrgUuids(orgUuids);
    }
  };

  const removeLegacyOrg = (legacyId) => {
    const newOrgStubs = newLegacyOrgs.filter((stub) => stub.id !== legacyId);
    const orgUuids = additionalLegacyOrgs
      ?.map((stub) => stub.id)
      .concat(newOrgStubs.map((stub) => stub.id));

    setNewLegacyOrgs(newOrgStubs);
    setAdditionalLegacyOrgUuids(orgUuids);
  };

  return (
    <PanelRow isWithCells={true} mods="Panel-row--header">
      <PanelCell mods="Panel-cell--header u-size3of12 u-flex">
        <h4>Legacy Seasons</h4>
      </PanelCell>
      <PanelCell mods="u-size9of12">
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12 u-colorWarning">
            <div className="u-spaceBottomMd">
              Do you want to add additional legacy seasons to this org from
              other legacy organizations? Example: multiple Clubs have merged to
              create one organization. Enter additional UUID numbers below to
              link legacy seasons with this organization. UUIDs can only be used
              once, either to link seasons or as the primary UUID number added
              in the field above.
            </div>
          </Cell>
        </Grid>
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12">
            <UUIDSearchForm
              buttonName={'Add'}
              setStubOrgData={setStubOrgData}
              isDisabled={!mainLegacyUuid}
            />

            {additionalLegacyOrgs?.map((legacyOrg) => (
              <div
                key={`additional-${legacyOrg.id}`}
                className="additional-legacy-connection u-borderColorDefault"
              >
                <span className="u-block u-fontSizeLg">{legacyOrg.name}</span>
                <span className="u-spaceXs u-block u-fontSizeSm">
                  {legacyOrg.id}
                </span>
              </div>
            ))}

            {newLegacyOrgs?.map((legacyOrg) => (
              <div
                key={`new-${legacyOrg.id}`}
                className="additional-legacy-connection u-borderColorDefault"
              >
                <Cell>
                  <span className="u-block u-fontSizeMd">{legacyOrg.name}</span>
                  <span className="u-spaceXs u-block u-fontSizeSm">
                    {legacyOrg.id}
                  </span>
                </Cell>

                <Cell>
                  <Button
                    onClick={() => removeLegacyOrg(legacyOrg.id)}
                    icon="dismiss"
                    size="large"
                    mods="u-colorPrimary6"
                  />
                </Cell>
              </div>
            ))}
          </Cell>
        </Grid>
      </PanelCell>
    </PanelRow>
  );
};

export default OrgEditAdditionalLegacyOrgsSection;
